import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ebw-monorepo-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss']
})
export class CustomButtonComponent {
  private _buttons: string[];
  private _styleContainer: string = 'btn-container';
  private _styleButton: string = 'btn-child';
  tempArray: string[];

  @Output() changeComponentHandler: EventEmitter<string> = new EventEmitter<string>();

  get buttons(): string[] {
    return this._buttons;
  }

  @Input() set buttons(buttons: string[]) {
    this._buttons = buttons;
    this.tempArray = [...this._buttons];
  }

  get styleContainer(): string {
    return this._styleContainer;
  }

  @Input() set styleContainer(styleContainer: string) {
    if (!!styleContainer) {
      this._styleContainer = styleContainer;
    }
  }

  get styleButton(): string {
    return this._styleButton;
  }

  @Input() set styleButton(styleButton: string) {
    if (!!styleButton) {
      this._styleButton = styleButton;
    }
  }

  constructor() {}

  changeComponent(btn: string) {
    this.tempArray = [...this._buttons];
    this.changeComponentHandler.emit(btn);
    // const index = this.tempArray.findIndex((value) => value === btn);
    // if (index !== -1)
    //   this.tempArray.splice(index, 1, this._backButton);
  }
}
